import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'

import { Observable } from 'rxjs'
import { distinctUntilChanged, switchMap, tap } from 'rxjs/operators'
import { Store } from '@ngrx/store'

import * as fromCoreStore from '@app/core/store'

import {
    LockedItem,
    FOLLOW_UP_RESOURCE,
    Order,
} from '@app/shared/models'
import { LockedItemWorkerFactory, LockItemWorker } from '@app/core/services/locked-item-worker.factory'
import { SessionEndService } from '@app/shared/services/session-end.service'

@Component({
    selector: 'app-candidates-router',
    template: `
      <div class="app-candidates-router">
        <app-candidate></app-candidate>
      </div>
  `,
    styles: [`
      .app-candidates-router {
        background-color: var(--bg-page);
        padding-bottom: 20px;
      }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CandidateItemRouterComponent implements OnInit, OnDestroy { 
    
    constructor(
        private store: Store<fromCoreStore.State>,
    ) { }
    ngOnInit(): void {
        
    }
    ngOnDestroy(): void {
        
    }

}